import { Icon, IconProps } from '@elkaso-app/web-design';
import { BiLineChart } from 'react-icons/bi';

export const AnalyticsIcon = (props: IconProps) => {
  return <Icon as={BiLineChart} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
